module.exports = "/assets/data/35f722671bac3415b8179778bad76176-BN25.data.json";